import axios from 'axios';

const merger_request_register_form = {
  namespaced: true,
  state() {
    return {
      data:{
        email: null,
      },
      errors: {},
      isLoadErrorConflict: false,
      isLoadErrorGone: false,
      isForbidden: false
    };
  },

  getters: {
    parameters(state) {
      return Object.assign({}, state.data);
    },
  },

  mutations: {
    setData(state, data) {
      state.data.email = data.email;
    },
    resetData(state) {
      state.data.email = null;
      state.isLoadErrorConflict = false,
      state.isLoadErrorGone = false,
      state.isForbidden = false
    },
    setErrors(state, errors) {
      state.errors = { ...errors };
    },
    setError(state, payload) {
      state.errors[payload.key] = payload.value;
    },
    clearError(state) {
      state.errors = {};
    },
    inputFormItem(state, payload) {
      if (state.data[payload.column] !== undefined) {
        state.data[payload.column] = payload.value;
      }
    },
    setLoadError(state, payload) {
      state.isLoadErrorConflict = (payload.status === 409);
      state.isLoadErrorGone = (payload.status === 410);
      state.isForbidden = (payload.status === 403);
    },
  },
  actions: {
    validate({ state, commit }) {
      commit('clearError');
      return new Promise((resolve, reject) => {
        if (!state.data.email) {
          commit('setError', { key: 'email', value: ['メールアドレスの入力は必須です。'] });
        }
        if (Object.keys((state.errors) || {}).length === 0) {
          resolve(true);
        } else {
          reject(state.errors);
        }
      });
    },
    register({ state, commit }) {
      return new Promise((resolve, reject) => {
        axios.post(
          `/api/brokerage_companies/merger_request`,
          {
            email: state.data.email
          })
        .then(() => {
          commit('resetData');
          resolve(true);
        })
        .catch((error) => {
          let handled = false;
          if (error.response.status === 422) {
            commit('setErrors', error.response.data.errors);
            handled = true;
          }
          if ([409, 410, 403].includes(error.response.status)) {
            commit('setLoadError', { status: error.response.status });
            handled = true;
          }
          reject({ handled });
        });
      });
    }
  }
};

export default merger_request_register_form;
